/**
 * Selection Overlay Component for WebGLChart
 * Renders a rectangular selection box during drag operations
 */

import React from 'react';
import { CHART_PADDING } from '../constants';

interface SelectionOverlayProps {
  startX: number;
  endX: number;
  startY: number;
  endY: number;
  chartHeight: number;
  active: boolean;
}

export const SelectionOverlay: React.FC<SelectionOverlayProps> = ({
  startX,
  endX,
  startY,
  endY,
  chartHeight,
  active,
}) => {
  if (!active) return null;

  const left = Math.min(startX, endX);
  const width = Math.abs(endX - startX);
  const top = Math.min(startY, endY);
  const height = Math.abs(endY - startY);

  // Clamp to chart area
  const clampedTop = Math.max(0, top);
  const clampedHeight = Math.min(height, chartHeight - clampedTop);

  // Show selection even if very small (no minimum size)
  if (width === 0 && height === 0) return null;

  return (
    <div
      className="absolute pointer-events-none"
      style={{
        left: CHART_PADDING.left + left,
        top: CHART_PADDING.top + clampedTop,
        width: Math.max(1, width),
        height: Math.max(1, clampedHeight),
        backgroundColor: 'rgba(59, 130, 246, 0.15)',
        border: '1px dashed rgba(59, 130, 246, 0.5)',
        zIndex: 10,
      }}
    />
  );
};
